import produce from "immer"
import { OkrSession } from "server/models"

import { OPEN } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initOkrSession: OkrSession = {
    id: null,
    accountId: null,
    sessionId: null,
    name: "",
    dateStart: null,
    dateEnd: null,
    cadence: null,
    cadenceUpdate: null,
    cadenceUpdateDay: null,
    color: null,
    owner: null,
    status: OPEN,
}

const initOkrSessionState: types.OkrSessionState = {
    sessionList: {},
    sessionIds: [],
    sessionView: initOkrSession,
    sessionEdit: initOkrSession,

    // to select parent
    availableSessions: [],

    // popup menu
    active: null,
    menuShow: false,
    menuTarget: null,

    showConfirmDelete: false,
    showArchived: false,

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const okrSessionReducer = produce((
    draft: types.OkrSessionState = initOkrSessionState,
    action: ActionTypes = null,
): types.OkrSessionState => {
    switch (action.type) {
        case types.OKR_SESSION_LIST:
            draft.sessionList = action.sessionList
            return draft

        case types.OKR_SESSION_IDS:
            draft.sessionIds = action.sessionIds
            return draft

        case types.OKR_SESSION_VIEW:
            draft.sessionView = action.session
            return draft

        case types.OKR_SESSION_EDIT:
            draft.sessionEdit = action.session
            return draft


        // to select parent
        case types.OKR_SESSION_AVAILABLE_SESSIONS:
            draft.availableSessions = action.sessions
            return draft


        // popup menu
        case types.OKR_SESSION_ACTIVE:
            draft.active = action.active
            return draft

        case types.OKR_SESSION_POPUP_MENU_SHOW:
            draft.menuShow = action.show
            return draft

        case types.OKR_SESSION_POPUP_MENU_TARGET:
            draft.menuTarget = action.target
            return draft

        case types.OKR_SESSION_SHOW_CONFIRM_DELETE:
            draft.showConfirmDelete = action.show
            return draft


        case types.OKR_SESSION_SHOW_ARCHIVED:
            draft.showArchived = action.show
            return draft


        case types.OKR_SESSION_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.OKR_SESSION_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.OKR_SESSION_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default okrSessionReducer
